import { render, staticRenderFns } from "./waldo.vue?vue&type=template&id=a1dc8be8"
import script from "./waldo.vue?vue&type=script&lang=js"
export * from "./waldo.vue?vue&type=script&lang=js"
import style0 from "./waldo.vue?vue&type=style&index=0&id=a1dc8be8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports